<template>
    <wire-frame-gdb>
        <template v-slot:top-main>
            <v-btn v-if="hasReceberPerm.value" :to="{ name:'checklist-db-aluno' }">Receber/Entregar Materiais</v-btn>
            <v-btn v-if="hasCriarListaPerm.value" :to="{ name:'checklist-db-listas' }">Listas per. Letivo</v-btn>
            <v-btn v-if="hasGerenciarPerm.value" :to="{ name:'checklist-db-materiais' }">Cadastro Materiais</v-btn>
            <v-btn v-if="hasFinanceiroPerm.value" :to="{ name:'checklist-db-devidos-financeiro' }">Devidos</v-btn>
            <v-divider class="my-2"></v-divider>
        </template>
    </wire-frame-gdb>
</template>
<script setup>
import { ref, computed } from 'vue';
import  { useRouter } from 'vue-router';
const hasReceberPerm = ref(false)
const hasCriarListaPerm = ref(false)
const hasGerenciarPerm = ref(false)
const hasFinanceiroPerm = ref(false)
const router = useRouter();
hasCriarListaPerm.value = computed(() => router.resolve({name: 'checklist-db-listas'}).meta.has_perm() )
hasReceberPerm.value = computed(() => router.resolve({name: 'checklist-db-aluno'}).meta.has_perm())
hasGerenciarPerm.value = computed(() => router.resolve({name: 'checklist-db-materiais'}).meta.has_perm())
hasFinanceiroPerm.value = computed(() => router.resolve({name: 'checklist-db-devidos-financeiro'}).meta.has_perm())
</script>